var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hld" },
    [
      _c("div", { staticClass: "wallet_detail_box" }, [
        _c("table", { staticClass: "list" }, [
          _vm._m(0),
          _c(
            "tbody",
            _vm._l(_vm.commissionData.data.list, function (item, index) {
              return _c("tr", { key: index }, [
                _c("td", [
                  _c("span", { staticClass: "price-text" }, [
                    _vm._v(_vm._s(item.amount)),
                  ]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "price-text" }, [
                    _vm._v(_vm._s(item.balance)),
                  ]),
                ]),
                _c("td", [_vm._v(_vm._s(item.detail))]),
                _c("td", [_vm._v(_vm._s(_vm.format_date(item.createdAt)))]),
                _c("div", { staticClass: "hover_box" }, [
                  _vm._v(_vm._s(item.gameID || "12343242")),
                ]),
              ])
            }),
            0
          ),
        ]),
        !_vm.commissionData.data.list.length
          ? _c("div", { staticClass: "none-item" }, [
              _c("div", [_vm._v("暂无数据")]),
              _c("img", {
                attrs: {
                  src: require("@/assets/images/none-item.svg"),
                  alt: "",
                },
              }),
            ])
          : _vm._e(),
      ]),
      _c("Page", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.commissionData.data.total > _vm.commissionData.size,
            expression: "commissionData.data.total > commissionData.size",
          },
        ],
        attrs: {
          current: _vm.commissionData.current,
          total: _vm.commissionData.data.total,
          "page-size": _vm.commissionData.size,
          "class-name": "page",
        },
        on: {
          "update:current": function ($event) {
            return _vm.$set(_vm.commissionData, "current", $event)
          },
          "on-change": _vm.pageF,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("额度")]),
        _c("th", [_vm._v("余额")]),
        _c("th", [_vm._v("详情")]),
        _c("th", [_vm._v("时间")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }